<template>
  <div>
    <el-dialog width="1200px" title="设计师作品上传" :visible.sync="dialogTableVisible">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <div class="demoboxAdd">
          <div>
            <el-form-item prop="worksImgs1">
              <!-- 平面？worksImgs1 ：modelImgs1 -->
              <UploadDesignerImg @worksImgs="worksImgs1"/>
            </el-form-item>
            <el-form-item class="formInput" label="作品名称" prop="worksName1">
              <el-input
                v-model="ruleForm.worksName1"
                placeholder="请填写作品名称"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item prop="worksImgs2">
              <UploadDesignerImg @worksImgs="worksImgs2"/>
            </el-form-item>
            <el-form-item class="formInput" label="作品名称" prop="worksName2">
              <el-input
                v-model="ruleForm.worksName2"
                placeholder="请填写作品名称"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item prop="worksImgs3">
              <UploadDesignerImg @worksImgs="worksImgs3"/>
            </el-form-item>
            <el-form-item class="formInput" label="作品名称" prop="worksName3">
              <el-input
                v-model="ruleForm.worksName3"
                placeholder="请填写作品名称"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item class="formAgree" prop="checked">
           <el-checkbox v-model="ruleForm.checked">
             <span>我已经阅读并同意</span>
             <span class="agreeMesg">《设计师入驻协议》</span>
             <span class="agreeMesg">《平台交易规则》</span>
           </el-checkbox>
        </el-form-item>
        <el-form-item class="desigerBtn">
          <el-button @click="resetForm('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 提交成功 -->
    <el-dialog width="800px" :show-close="false"
      class="submitCenter"
      :visible.sync="submitSuccess"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <img src="../../assets/images/pass.png" alt="">
      <p>提交成功，您已完成平面设计师入驻！</p>
      <div>
        <el-button type="primary" @click="getSAuccessful('back')">返回</el-button>
        <el-button type="primary" @click="getSAuccessful('workMsag')">完善作品信息</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {designerInAgain,getMenuList} from "../../utils/interface";
import UploadDesignerImg from "../../components/uploadDesignerImg/uploadDesignerImg.vue"
import UploadDesignerModel from "../../components/uploadDesignerModel/uploadDesignerModel.vue"

export default {
  components: {
    UploadDesignerImg,
    UploadDesignerModel
  },
  data() {
    return {
      dialogTableVisible: false,
      submitSuccess: false,
      ruleForm: {
        worksImgs1: "",
        worksImgs2: "",
        worksImgs3: "",
        worksName1: "",
        worksName2: "",
        worksName3: "",

        checked: null,
          designerAttachmentList:[],
      },
        fileList:[],
      rules: {
        worksImgs1: [
          { required: true, message: "请上传作品图片", trigger: "blur" },
        ],
        worksImgs2: [
          { required: true, message: "请上传作品图片", trigger: "blur" },
        ],
        worksImgs3: [
          { required: true, message: "请上传作品图片", trigger: "blur" },
        ],
        worksName1: [
          { required: true, message: "请填写作品名称", trigger: "blur" },
        ],
        worksName2: [
          { required: true, message: "请填写作品名称", trigger: "blur" },
        ],
        worksName3: [
          { required: true, message: "请填写作品名称", trigger: "blur" },
        ],
        checked: [
          { required: true, message: "请阅读并勾选入驻协议以及平台规则", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    init() {
      this.dialogTableVisible = true;
    },
    worksImgs1(img){
      this.ruleForm.worksImgs1 = img
      this.$refs.ruleForm.validateField('worksImgs1');
    },
    worksImgs2(img){
      this.ruleForm.worksImgs2 = img
      this.$refs.ruleForm.validateField('worksImgs2');
    },
    worksImgs3(img){
      this.ruleForm.worksImgs3 = img
      this.$refs.ruleForm.validateField('worksImgs3');
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            this.fileList.push({
                attachmentType: "GRAPHIC",
                fileName: this.ruleForm.worksImgs1.name,
                fileUrl: this.ruleForm.worksImgs1.url,
                workName: this.ruleForm.worksName1,
                workOrder: 1
            });
            this.fileList.push({
                attachmentType: "GRAPHIC",
                fileName: this.ruleForm.worksImgs2.name,
                fileUrl: this.ruleForm.worksImgs2.url,
                workName: this.ruleForm.worksName2,
                workOrder: 2
            });
            this.fileList.push({
                attachmentType: "GRAPHIC",
                fileName: this.ruleForm.worksImgs3.name,
                fileUrl: this.ruleForm.worksImgs3.url,
                workName: this.ruleForm.worksName3,
                workOrder: 3
            });
            this.ruleForm.designerAttachmentList = this.fileList;
            designerInAgain(this.ruleForm).then((response) => {
                if (response.success) {
                    this.$message({
                        type: "success",
                        message: "提交成功",
                    });
                    this.submitSuccess = true
                    this.dialogTableVisible = false
                } else {
                    this.$message({
                        type: "error",
                        message: response.message,
                    });
                }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 取消
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogTableVisible = false;
    },
    async getSAuccessful(type){
      if(type == 'back'){
        this.submitSuccess = false
        this.$router.go(0);
      }else {
        this.submitSuccess = false
        let res = await getMenuList()
        if(res.length > 0){
          window.sessionStorage.setItem('menuList', JSON.stringify( res || []))
          this.$store.commit('menuListShowVuex',true)
          this.$router.push('/worksManagement')
        }
      }
    }

  },
};
</script>

<style lang="less" scoped>
.demoboxAdd {
  display: flex;
  justify-content: space-around;
  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
  .formInput /deep/.el-form-item__content {
    margin-left: 100px !important;
  }
}
.formAgree {
  .agreeMesg {
    color: #1890ff;
  }
}
.desigerBtn {
  text-align: center;
  margin-top: 30px;
}
.submitCenter {
  text-align: center;
  img {
    width: 70px;
  }
  p {
    margin: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/graphicCertification.vue